import React, { Component } from 'react';

import PopularListItem from './PopularListItem';
import NotPopularListItem from './NotPopularListItem';

export default class List extends Component {
  render() {
    const { popularCategories, notPopularCategories, handleSelectCategory } =
      this.props || [];
    return (
      <div className="row">
        <div className="col-sm-7">
          <h5>Most Popular Categories</h5>
          <ul className="search-categories">
            {(popularCategories.length &&
              popularCategories.map(category => (
                <PopularListItem
                  key={category.id}
                  handleSelectCategory={handleSelectCategory}
                  category={category}
                />
              ))) || <noscript />}
          </ul>
        </div>
        <div className="col-sm-5">
          <h5>More Categories</h5>
          <ul className="white-bg other-list">
            {(notPopularCategories.length &&
              notPopularCategories.map(category => (
                <NotPopularListItem
                  key={category.id}
                  handleSelectCategory={handleSelectCategory}
                  category={category}
                />
              ))) || <noscript />}
          </ul>
        </div>
      </div>
    );
  }
}
